import {
  FETCH_PRELOADED_CAMPAIGNS,
  GET_PRELOADED_CAMPAIGN,
  CREATE_PRELOADED_CAMPAIGN,
  UPDATE_PRELOADED_CAMPAIGN,
  DELETE_PRELOADED_CAMPAIGN,
  DISBURSE_PRELOADED_CAMPAIGN,
} from 'actions/preloadedCampaign';
import { toast } from 'react-toastify';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  preloadedCampaigns: [],
  preloadedCampaignDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const preloadedCampaignReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_PRELOADED_CAMPAIGNS.REQUEST:
    case GET_PRELOADED_CAMPAIGN.REQUEST:
    case CREATE_PRELOADED_CAMPAIGN.REQUEST:
    case UPDATE_PRELOADED_CAMPAIGN.REQUEST:
    case DELETE_PRELOADED_CAMPAIGN.REQUEST:
    case DISBURSE_PRELOADED_CAMPAIGN.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_PRELOADED_CAMPAIGNS.SUCCESS: {
      // Backend returns a plain array (session-level-offers style).
      const list = Array.isArray(payload) ? payload : payload.results || [];
      return {
        ...state,
        isLoading: false,
        preloadedCampaigns: list,
        page: payload.page || 1,
        limit: payload.limit || list.length,
        totalPages: payload.totalPages || 1,
        total: payload.totalResults || list.length,
      };
    }

    case GET_PRELOADED_CAMPAIGN.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        preloadedCampaignDetail: Array.isArray(payload) ? payload[0] || {} : payload,
      };
    }

    case CREATE_PRELOADED_CAMPAIGN.SUCCESS: {
      toast.success('Pre-loaded campaign created successfully');
      return {
        ...state,
        isLoading: false,
        preloadedCampaigns: _.concat(state.preloadedCampaigns, payload),
      };
    }

    case UPDATE_PRELOADED_CAMPAIGN.SUCCESS: {
      toast.success('Pre-loaded campaign updated successfully');
      return {
        ...state,
        isLoading: false,
        preloadedCampaigns: state.preloadedCampaigns.map((data) =>
          data.id === payload.id ? payload : data
        ),
      };
    }

    case DELETE_PRELOADED_CAMPAIGN.SUCCESS: {
      toast.success('Pre-loaded campaign deleted successfully');
      return {
        ...state,
        isLoading: false,
        preloadedCampaigns: state.preloadedCampaigns.filter((data) => data.id !== payload),
      };
    }

    case DISBURSE_PRELOADED_CAMPAIGN.SUCCESS: {
      return { ...state, isLoading: false };
    }

    case FETCH_PRELOADED_CAMPAIGNS.FAIL:
    case GET_PRELOADED_CAMPAIGN.FAIL:
    case CREATE_PRELOADED_CAMPAIGN.FAIL:
    case UPDATE_PRELOADED_CAMPAIGN.FAIL:
    case DELETE_PRELOADED_CAMPAIGN.FAIL:
    case DISBURSE_PRELOADED_CAMPAIGN.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return state;
  }
};

export default preloadedCampaignReducer;
